import { home } from "./engb";

const engb = {
	home: home,
};

export default engb;
